import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, inject, input, OnDestroy, OnInit, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { OnboardingFacade } from '@zero/onboarding/domain';
import { LoadingIndicatorDirective } from '@zero/shared/ui-directives';
import { ButtonComponent, IconComponent } from '@zero/shared/ui-web-design-system';
import { RouteOptionsService } from '@zero/shared/util-web-app-services';
import { ExitIntentComponent } from '../exit-intent/exit-intent.component';
import { FooterComponent } from '../footer/footer.component';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';

@Component({
  selector: 'onboarding-container',
  imports: [
    FooterComponent,
    ExitIntentComponent,
    ProgressBarComponent,
    IconComponent,
    ButtonComponent,
    TranslocoPipe,
    AsyncPipe,
    LoadingIndicatorDirective,
    NgClass,
    NgTemplateOutlet,
  ],
  templateUrl: './onboarding-container.component.html',
  styleUrl: './onboarding-container.component.scss',
})
export class OnboardingContainerComponent implements OnInit, OnDestroy {
  public hideLogout = input<boolean>(false);
  public hideForward = input<boolean>(false);
  public hideBack = input<boolean>(false);
  public displayProgressBar = input<boolean>(true);
  public formValid = input<boolean>(false);
  public specialAction = input<string>();
  public specialActionColor = input<'link' | 'course-red' | 'course-green'>('link');
  public buttonLabel = input<string>();
  public loading = input<boolean>(false);
  public error = input<Error>();

  public forward = output<void>();
  public back = output<void>();
  public specialActionClicked = output<void>();

  public readonly facade = inject(OnboardingFacade);

  readonly #routeOptionsService = inject(RouteOptionsService);

  ngOnInit(): void {
    this.#routeOptionsService.hideHeaderAndFooter();
    document.body.classList.add('box-white');
  }

  ngOnDestroy(): void {
    this.#routeOptionsService.displayHeaderAndFooter();
    document.body.classList.remove('box-white');
  }
}
